<template>
  <TemplateBase>
    <client-only>
      <main v-if="!hasUser" class="relative z-0 col-span-full row-start-2">
        <OrganismNavigationBreadcrumb class="mb-2 mx-auto p-4 md:container md:mb-8 md:pb-0 md:pt-10 xl:mb-20" :path="breadcrumbs" />

        <section class="container relative z-10 mx-auto 2xl:px-20 md:mb-16 md:px-6 lg:px-8 xl:px-12">
          <div class="flex flex-col pt-8 w-full md:flex-row">
            <div class="fixed-width flex flex-col shrink-0">
              <div class="max-dimensions-avatar flex mb-4 ml-auto mr-auto rounded-xl overflow-hidden">
                <figure>
                  <!-- TODO: user icon or fixed icon -->
                  <img src="/images/user_avatar.png" class="cover-fill w-full h-full" />
                </figure>
              </div>
              <div class="flex flex-col ml-auto mr-auto text-center">
                <h1 class="mb-2 text-2xl text-xl font-bold leading-7 uppercase">{{ $t('register.login') }}</h1>
                <p class="mb-2">{{ $t('register.subtitle-register-form') }}</p>
              </div>
            </div>
            <div class="w-full">
              <div class="flex items-center p-8 bg-white border-b-2 border-solid border-app-green-100 rounded-xl">
                <MoleculeUserRegisterForm />
              </div>
            </div>
          </div>
        </section>
      </main>
    </client-only>
  </TemplateBase>
</template>

<script setup lang="ts">
import { setupRequireNoUser } from '~/composables/user'
import { getSiteConfig } from '~/composables/craft'
import { setCacheControlHeader } from '~/composables/util'
import { useNavigationStore } from '~/store/navigation'

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    nl: '/ikzoekbaas/account/registreren',
  },
})

const route = useRoute()
const i18n = useI18n()
const localePath = useLocalePath()
const navigationStore = useNavigationStore()

const { hasUser } = setupRequireNoUser()

const breadcrumbs = [
  { url: localePath({ name: 'izb-home-detail' }), label: i18n.t('ikzoekbaas') },
  { url: localePath({ name: 'account-register' }), label: i18n.t('register.title') },
]

const { site } = getSiteConfig(route)
await navigationStore.fetch(site)
setCacheControlHeader()
</script>

<style lang="scss" scoped>
.fixed-width {
  @screen md {
    width: 250px;
  }
}

.bottom-fixed-margin {
  @screen md {
    margin-left: 200px;
  }
}

.max-dimensions-avatar {
  width: 109px;
  height: 109px;
}
</style>
